import styles from './RelatedPosts.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface RelatedPostsDetail {
  title: string
  link: string
  thumbnail: string
  day: string
  category: string
}

export interface RelatedPostsItem {
  sectionTitle: string
  relatedPosts: RelatedPostsDetail[]
}

interface Props {
  RelatedPostsEach: RelatedPostsItem[]
}

const RelatedPosts: React.FC<Props> = ({ RelatedPostsEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  if (!RelatedPostsEach || RelatedPostsEach.length === 0) {
    return null
  }

  const item = RelatedPostsEach[0]

  return (
    <section
      className={`${styles.relatedPosts} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
      <div className={styles.scroll}>
        <div className={styles.post}>
          {item.relatedPosts.map((post) => (
            <article key={post.title} className={styles.columnitem}>
              <a href={post.link} aria-label={`${post.title}の詳細を見る`}>
                <figure className={styles.imgContainer}>
                  <img
                    src={post.thumbnail}
                    className={styles.image}
                    alt={`${post.title}のサムネイル画像`}
                    width={280}
                    height={186}
                  />
                </figure>
                <div className={styles.textwrap}>
                  <span className={styles.day}>{post.day}</span>
                  <h4 className={styles.column__title}>{post.title}</h4>
                  <p className={styles.column__category}>{post.category}</p>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default RelatedPosts
